import { PaginationType } from "@store/Pagination";
import dayjs from "dayjs";

export const formatPrice = (v: number) => {
  let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",

    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
  });
  return formatter.format(v / 100); /* $2,500.00 */
};

export const getDateFormatted = (fullDate: Date) => {
  const date = ("0" + fullDate.getDate()).slice(-2);
  const month = ("0" + (fullDate.getMonth() + 1)).slice(-2);
  const year = fullDate.getFullYear();

  return `${year}-${month}-${date}`;
};

export const formatTimeTwoDigital = (time: string) => {
  return dayjs("1/1/1 " + time).format("hh:mm a");
};

export const formatSecondsToHms = (time: number) => {
  let h = Math.floor(time / 3600);
  let m = Math.floor((time % 3600) / 60);
  let s = Math.floor((time % 3600) % 60);

  let hDisplay = h > 0 ? (h > 9 ? h : `0${h}`) : "00";
  let mDisplay = m > 0 ? (m > 9 ? m : `0${m}`) : "00";
  let sDisplay = s > 0 ? (s > 9 ? s : `0${s}`) : "00";

  return `${hDisplay} : ${mDisplay} : ${sDisplay}`;
};

export const jsonParsePagination = (pagination: string): PaginationType => {
  const parse = JSON.parse(pagination);

  return {
    currentPage: parse.CurrentPage,
    pageSize: parse.PageSize,
    totalPages: parse.TotalPages,
    totalCount: parse.TotalCount,
    hasNext: parse.HasNext,
    hasPrevious: parse.HasPrevious,
  };
  // "{"CurrentPage":1,"TotalPages":5,"PageSize":1,"TotalCount":5,"HasPrevious":false,"HasNext":true}"
};
